import type { MenuScreen } from '../types.js';
import { createScreenShell, createMenuHeader, createCrestButton, el } from '@bn-games/ui-shell';
import { t } from '../../i18n/I18n.js';
import { APP_VERSION } from '../../utils/constants.js';

export function createAboutScreen(): MenuScreen {
  let frame: HTMLElement | null = null;

  return {
    mount(root, ctx) {
      const shell = createScreenShell();
      frame = shell.frame;
      const body = shell.body;

      body.appendChild(createMenuHeader({ title: t('about.title') }));

      const about = el('div', {
        class: 'about',
        attrs: { role: 'region', 'aria-label': t('about.title'), tabindex: '0' },
      }, [
        el('p', { class: 'about-paragraph', text: `${t('app.name')} v${APP_VERSION}` }),
        el('p', { class: 'about-paragraph', text: t('about.body') }),
      ]);
      body.appendChild(about);

      const back = el('div', { class: 'button-row back-button-row' }, [
        createCrestButton({ label: t('common.back'), small: true, onClick: () => ctx.navigate('menu') }),
      ]);
      body.appendChild(back);

      root.appendChild(frame);
    },
    unmount() {
      frame?.remove();
      frame = null;
    },
  };
}
